import Interfaces from "./_interfaces";
import Modal from "./_bootstrapModalExtensions";
import * as Url from "./Utils/UrlUtil";
import NotificationUtil from "./_notificationUtil"
import * as DxRichEdit from "./_dxRichEdit";

export function AfterSignOffChanges(clerkName: string, filingState: string) {
    $('#signed-clerk-display-name-cell').text(clerkName);

    if (filingState) {
        $('#fado-state-cell').text(filingState);
    }
}

export function CheckIfTemplateExists(template) {
    if (template == undefined || template.length == 0) {
        Modal.showAlertWindow('Nem adott meg sablont, kérem pótolja!', 'Hiba');
        return false;
    }

    return true;
}

export function EditDocumentByDocumentEditor(event: JQuery.TriggeredEvent) {
    let $editButton: JQuery = $(event.target);
    $editButton.attr('disabled', 'disabled');

    let processActionId: number = $('#filingvars').data('processaction-id');

    const promise = new Promise((resolve, reject) => {
        resolve(CheckIfDocumentIsLocked(processActionId, $editButton));
    })
        .then((res: Interfaces.DocumentEditorControllerResponse) => {
            if (res.result) {
                ConfirmDocumentLock(processActionId, $editButton, res);
            } else {
                OpenDocumentForRichEdit(processActionId, $editButton);
            }
        })
        .catch((err: JQuery.jqXHR) => {
            NotificationUtil.Error(err.responseText, 'Hiba');
        });
}

function CheckIfDocumentIsLocked(processActionId: number, $editButton: JQuery): Promise<Interfaces.DocumentEditorControllerResponse> {
    return new Promise((resolve) => {
        $.ajax({
            method: "POST",
            url: window.ETDR_RD.appConfig["UrlAction.CheckIfDocumentIsLocked"],
            data: { 'processActionId': processActionId },
            headers: { Accept: 'application/json' }
        })
            .done((response: Interfaces.DocumentEditorControllerResponse) => {
                if (!response.success) {
                    let errorText: string;

                    if (response.message) {
                        errorText = response.message;
                    } else {
                        errorText = 'Hiba történt a dokumentum állapotának ellenőrzése során.';
                    }

                    NotificationUtil.Error(errorText);
                }

                resolve(response);
            })
            .fail((jqXHR) => {
                $('.doc-edit-btn').removeAttr('disabled');
                NotificationUtil.Error(jqXHR.responseText, 'Hiba');
            });
    });
}

function ConfirmDocumentLock(processActionId: number, $editButton: JQuery, documentLockResult: Interfaces.DocumentEditorControllerResponse) {
    let lockerName: string = documentLockResult.userName;

    Modal.showConfirmationWindowAsync(
        `<b>A dokumentumot <em>${lockerName}</em> szerkesztésre zárolta.</b> <b>Kérjük, döntse el, hogy valóban folytatja-e a műveletet!</b><br /><br />Amennyiben a folytatás mellett dönt, <em>${lockerName}</em> nem fogja tudni elmenteni a dokumentumot.`,
        'Figyelmeztetés',
        () => { DxRichEdit.ForceUnLockDocumentAndOpenForEdit(processActionId, $editButton); },
        () => { $editButton.removeAttr('disabled'); },
        'Folytatás',
        'Mégse'
    );
}

export function OpenDocumentForRichEdit(processActionId: number, $editButton: JQuery) {
    let urlTemplate: string;
    let url: string;

    if ($editButton.attr('id') === 'doc-dx-web-editor') {
        urlTemplate = window.ETDR_RD.appConfig["UrlTemplate.DocumentDxWebEditor"];
    } else {
        urlTemplate = window.ETDR_RD.appConfig["UrlTemplate.GenerateDocumentByOffice"];
    }

    url = Url.createUrlFromTemplate(urlTemplate, { processActionId: processActionId })

    $('.doc-edit-btn').removeAttr('disabled');

    location.href = url;
}

export function RefreshDocument(event: JQuery.TriggeredEvent) {
    let $self: JQuery = $(event.target);
    $self.attr('disabled', 'disabled');

    let $filingvars = $('#filingvars');
    let processActionId: string = $filingvars.data('processaction-id');
    let url: string = Url.createUrlFromTemplate(window.ETDR_RD.appConfig['UrlTemplate.RefreshDocument'], { processActionId: processActionId });

    $self.removeAttr('disabled');

    location.href = url;
}

jQuery(() => {
    $('.doc-edit-btn').click((event: JQuery.TriggeredEvent) => EditDocumentByDocumentEditor(event));
    $('.doc-refresh-btn').click((event: JQuery.TriggeredEvent) => RefreshDocument(event));
});
